// 支付通道 / 收款主体 (缺口 B) — 起 App 时「这个 App 用哪个收款主体/通道」的配置面.
//
// 现状: 银联多主体收款 (OPEN-BODY-SIG)、微信/支付宝/RevenueCat 的路由逻辑已在后端
// 代码 + 集成密钥里, 但没有独立的配置/对账页. 待建 /admin/v1/payments.

import { PlaceholderPage } from '@/components/PlaceholderPage';

export function PaymentChannelsPage() {
  return (
    <PlaceholderPage
      title="支付通道 / 收款主体"
      description="管理各 App 的收款主体与支付通道路由 — 起新 App 时可自助选「用哪个主体收款、走哪条通道」, 并做对账."
      planned={[
        '收款主体管理 (银联商务多主体 / 微信 / 支付宝 / RevenueCat)',
        '通道路由规则 (App × 端 → 主体 / 通道)',
        '主体凭证状态与到期提醒 (与集成密钥联动)',
        '支付对账台账 (订单 ↔ 通道回调 ↔ 到账)',
      ]}
      backend={{
        ready: false,
        note: '银联多主体收款逻辑已上线 (代码 + 集成密钥), 但无独立配置 API. 待建 /admin/v1/payments (主体 CRUD + 路由规则 + 对账查询).',
      }}
    />
  );
}
